<template>
    <div id="Authentication">
        <Nav />
        <el-main class="content">
            <div v-if="status ==='wait'" class="status">

                <i class="el-icon-success" style="color:#16b1b3; margin-right:5px;"></i>提交成功，审核结果将在一个工作日以内以短信形式通知您
            </div>
            <div v-else-if="status ==='failed'" class="status">
                <i class="el-icon-error" style="color:red; margin-right:5px;"></i><strong style="margin-left:0px;">审核不通过，不通过理由：</strong>{{data.auth_fail_reason}}    <br/><strong style="margin-left:32px;">请修改后重新提交!</strong>
                <el-button type="primary" size="medium" @click="toEdit" style="margin-left:20px;" plain round>去修改<i class="el-icon-arrow-right el-icon--right"></i></el-button>
            </div>
            <el-row class="info">
                <el-col :span="6" >
                    <img :src="data.logo"/>
                    <p style="width:50%; text-align:center;margin:0 auto;">账号头像</p>
                </el-col>
                <el-col :span="9">
                    <p>账号名称：<span>{{data.auth_name}}</span></p>
                    <p>认证说明：<span>{{data.auth_info}}</span></p>
                    <p class="clearfix"><i class="introT">账号介绍：</i><span class="intro">{{data.intro}}</span></p>
                    <p>机构名称：<span>{{data.company_name}}</span></p>
                </el-col>
                <el-col :span="9">
                    <p>审核状态： <span :class="status === 'wait'? 'wait':'fail'">{{statusText}}</span></p>
                    <p>申请时间：<span>{{time}}</span></p>                
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script>
import Nav from '@/components/common/nav'
import userAgreement from '@/components/UserAgreement'
import { getInfo, getUserInfo } from '@/api/auth'
import { setToken, setUid, getUid } from '@/utils/index'
import dayjs from 'dayjs'
export default {
    name: "Authstatus",
    components: {
        Nav,
        userAgreement,
    },
    data(){
        return{
            data: {},
            userAgreement: true,
            companyData: {},
            authData: {},
            time:'',
            status: '',
            params: '',
            statusText: '',
        }
    },
    methods: {
        toUserAgreement() {
            $('#userAgreement').modal('show')
        },
        async fetchData() {
            this.companyData = this.$route.params
            const Uid = getUid()
            if(this.companyData.company_auth_status) {
                this.status = this.companyData.company_auth_status
                this.params = {
                    'operator_mobile': this.companyData.mobile
                }
            } else if (this.companyData.progress) {
                this.status = this.companyData.progress
                this.params = {
                    'operator_mobile': this.companyData.operator_mobile
                }
            }  else {  
                if (Uid) {
                    const { data } = await getUserInfo(Uid)
                    this.status = data.data.company_user.company_auth_status
                    if (this.status === 'wait') {
                        this.statusText = '审核中'
                    } else if(this.status === 'success') {
                        this.statusText = '审核成功'
                    } else{
                        this.statusText = '审核失败'
                    }
                    if(this.status === "success"){
                        window.location.href= process.env.ADMIN_URL
                    } else {
                        this.params = {
                         'operator_mobile': data.data.company_user.mobile
                        }
                    }
                }
            }
            if (this.params) {
                this.authData = await getInfo(this.params)
                this.data = this.authData.data.data.auth
                this.time = dayjs(this.data.submit_time).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        toEdit() {           
            this.$router.push({
                name: 'Authentication',
                params: this.data
            })
        }
    },
    mounted(){
        document.getElementsByClassName('navbar-inverse')[0].setAttribute('style','position:relative')
        this.fetchData()
    }
}
</script>

<style scoped lang="scss" >
#Authentication  #navs{
    background: #000;
    position:inherit;
}
.userAgreement{
    font-size: 12px; 
}
.content{
    width:70%;
    margin: 50px auto;
    .status{
        border:1px solid #16b1b3;
        border-radius: 8px;
        font-size: 18px; 
        text-align: left;
        line-height: 40px;
        box-shadow:2px 2px 5px #c5f6f7;
        padding: 20px;
        text-indent: 20px;
    }
    .info {
        margin-top:30px;
        border-radius: 8px;
        border:1px solid #16b1b3;
        padding:30px;
        box-shadow:2px 2px 5px #c5f6f7;
        text-align: left;
    }
    .intro{
        float: left;
        display: inline-block;
        width: 250px;
        line-height: 30px;
        word-break: break-all;
        
    }
    .introT{
        float: left;
        font-style: normal;
    }
    img{
        display: block;
        width: 50%;
        margin:0 auto;
    }
    p{
        line-height: 30px;
        font-size: 14px; 
        font-weight: bold;
        text-align: left;
        span{
            font-weight: normal;
        }
    }
    .wait{
        color:green;
    }
    .fail{
        color:red;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Authstatus.vue